<div
  class="row vh-100 d-flex justify-content-center align-items-center vw-100"
  [ngClass]="{
    'app-bg-mono': bgColor === BgColor.MONO || !isValidBgColor,
    'app-bg-img-full': bgColor === BgColor.IMG
  }"
  [appTriggerChoice]="mode === 'reading' ? 'reading' : type"
  (onKeypress)="navigateToNext()"
  >
  @if (showConsent) {
    <div>
      <app-consent-form [route]="route"></app-consent-form>
    </div>
  }

  @if (!showConsent && !isFinalPage) {
    <div
      class="col-xl-6 col-md-8 col-sm-10 col-xs-12 d-flex justify-content-center align-items-center"
      >
      <div class="card shadow">
        <div class="card-header font-weight-bold">
          {{ title ? title : 'Instruction' }}
        </div>
        <div class="card-body d-flex flex-column">
          @if (instructions['illustration']) {
            <div class="align-self-center">
              <img [src]="illustration" class="img-fluid illustration" />
            </div>
          }
          <div class="card-text mt-3" [innerHTML]="body"></div>
          @if (showContinue) {
            <div class="app-button-container mt-3">
              <app-continue-button [route]="route" [label]="label"></app-continue-button>
            </div>
          }
        </div>
      </div>
    </div>
  }

  @if (!showConsent && isFinalPage) {
    <div
      class="col-xl-6 col-md-8 col-sm-10 col-xs-12 d-flex justify-content-center align-items-center"
      >
      <div class="card shadow">
        <div class="card-header font-weight-bold">
          {{ title ? title : 'Vielen Dank!' }}
        </div>
        <div class="card-body d-flex flex-column">
          @if (instructions['illustration']) {
            <div class="align-self-center">
              <img [src]="illustration" class="img-fluid illustration" />
            </div>
          }
          <div class="card-text mt-3">
            <div class="app-final-instruction" [innerHTML]="body"></div>
            <!-- <p >
            {{ outroLabels.before_link }}
            <a
              href="#"
              rel="noopener noreferrer"
              (click)="handleStudyFinish($event)"
              title="Back to the recruiting agency"
              ><u>{{ outroLabels.in_link }}</u></a
              >
              {{ outroLabels.after_link }}
            </p> -->
          </div>
          @if (showContinue) {
            <div class="app-button-container mt-3">
              <app-continue-button [route]="route" [label]="label"></app-continue-button>
            </div>
          }
        </div>
      </div>
    </div>
  }
</div>
